<template>
    <div>
        <div v-if="!getProductsForPurchasePending">
            <section style="min-height: 80vh;">
                <div class="q-pt-md">
                    <div class="row items-center container" style="padding-bottom: 0;">
                        <div class="col items-center">
                            <p class="text-h4 text-weight-bold q-mb-sm">Product Pricing</p>
                        </div>
                        <div class="col items-center q-my-auto">
                            <currency-select class="q-mx-xs q-mb-sm" :fullWidth="screenSize.xs" />
                        </div>
                    </div>
                </div>

                <div class="container row">
                    <!-- LoopCAD -->
                    <div class="col-xs-12 col-sm-6 col-md-3 q-pb-lg">
                        <div>
                            <div class="row justify-center text-center q-col-gutter-sm items-stretch">
                                <div class="col-11">
                                    <store-product :selectedCurrency="cart.currency"
                                                   :productLogo="productLines.LoopCAD.logo"
                                                   :productPage="productLines.LoopCAD.page"
                                                   :productName="productLines.LoopCAD.name"
                                                   :lowestLicensePrice="lcLowestLicensePrice"
                                                   :productDescription="productTypes[0].products.find(({ name }) => name === 'LoopCAD').description"
                                                   @scrollToEditions="ScrollTo($refs.lcEditionsRef, '#lcEditions')">
                                    </store-product>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- HeatCAD -->
                    <div class="col-xs-12 col-sm-6 col-md-3 q-pb-lg">
                        <div>
                            <div class="row justify-center text-center q-col-gutter-sm items-stretch">
                                <div class="col-11">
                                    <store-product :selectedCurrency="cart.currency"
                                                   :productLogo="productLines.HeatCAD.logo"
                                                   :productPage="productLines.HeatCAD.page"
                                                   :productName="productLines.HeatCAD.name"
                                                   :lowestLicensePrice="hcLowestLicensePrice"
                                                   :productDescription="productTypes[0].products.find(({ name }) => name === 'HeatCAD').description"
                                                   @scrollToEditions="ScrollTo($refs.hcEditionsRef, '#hcEditions')">
                                    </store-product>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- PlumbingCAD -->
                    <div class="col-xs-12 col-sm-6 col-md-3 q-pb-lg">
                        <div>
                            <div class="row justify-center text-center q-col-gutter-sm items-stretch">
                                <div class="col-11">
                                    <store-product :selectedCurrency="cart.currency"
                                                   :productLogo="productLines.PlumbingCAD.logo"
                                                   :productPage="productLines.PlumbingCAD.page"
                                                   :productName="productLines.PlumbingCAD.name"
                                                   :lowestLicensePrice="pcAnnualPrice"
                                                   :productDescription="productTypes[0].products.find(({ name }) => name === 'PlumbingCAD').description"
                                                   @scrollToEditions="ScrollTo($refs.pcEditionsRef, '#pcEditions')">
                                    </store-product>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Lengthwise -->
                    <div class="col-xs-12 col-sm-6 col-md-3 q-pb-lg">
                        <div v-for="([key, value]) in otherProductsByYear" :key="key">
                            <div class="row justify-center text-center q-col-gutter-sm items-stretch">
                                <div v-for="prod in value" :key="prod.id" class="col-11">
                                    <store-product :id="prod.id" :product="prod"
                                                   :selectedCurrency="cart.currency"
                                                   :productLogo="productLines.LengthWise.logo"
                                                   :productPage="productLines.LengthWise.page"
                                                   :productName="productLines.LengthWise.name"
                                                   :productYear="key"
                                                   :productDescription="productTypes[1].products.find(({ name }) => name === 'LengthWise').description"
                                                   @buy="addToCart">
                                    </store-product>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="container">
                    <!-- LoopCAD Editions -->
                    <div id="lcEditions" ref="lcEditionsRef">
                        <div v-for="([key, value]) in newLoopCADLicensesByYear" :key="key">
                            <div class="q-pb-lg row" style="display: flex; justify-content: space-between; align-items: center;">
                                <div class="store-category-logo" style="margin-left:calc(50% - 200px);">
                                    <router-link :to="productLines.LoopCAD.page">
                                        <img :src="productLines.LoopCAD.logo" :title="productLines.LoopCAD.name" class="img-logo" />
                                        <sup class="text-black text-h5 text-weight-bold on-right" style="vertical-align: top">{{ key }}</sup>
                                    </router-link>
                                </div>
                                <div class="text-primary text-right" style="font-size: 0.8rem; padding: 14px; width: 200px;">
                                    <a href="/support/faqs?productLine=LoopCAD" style="text-decoration: underline; font-weight: normal;">Subscription FAQs</a>
                                    <br />
                                    <label @click="showMultiLicenseDiscount = true" style="cursor: pointer; text-decoration: underline;">Multiple License Discount</label>
                                </div>
                            </div>
                            <div>
                                <div class="row justify-center text-center q-col-gutter-lg items-stretch q-mt-md">
                                    <div v-for="prod in value" :key="prod.id"
                                         class="col-xs-12 col-sm-6 col-md-4 q-pb-xl">
                                        <div :class="editionSalesFlag(prod) ? 'edition-sales-flag-borders' : ''" style="padding: 14px;">
                                            <div v-for="renewal in subscriptionRenewals.filter(p => p.productCategoryID == 'LoopCAD' && p.version == key && p.edition == prod.edition)" :key="prod.id" class="col-xs-12 col-sm-6 col-md-4">
                                                <store-product :id="prod.id" :product="prod" :renewal="renewal"
                                                               :selectedCurrency="cart.currency"
                                                               :editionSalesFlag="editionSalesFlag(prod)"
                                                               :features="productTypes[0].products.find(({ name }) => name === 'LoopCAD').featuresCompare[prod.edition]"
                                                               @buy="addToCart" @renew="addToCart">
                                                </store-product>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- HeatCAD Editions -->
                    <div id="hcEditions" ref="hcEditionsRef" class="q-pt-xl">
                        <div v-for="([key, value]) in newHeatCADLicensesByYear" :key="key" class="q-pt-sm">
                            <div class="q-pb-lg row" style="display: flex; justify-content: space-between; align-items: center;">
                                <div class="store-category-logo" style="margin-left:calc(50% - 200px);">
                                    <router-link :to="productLines.HeatCAD.page">
                                        <img :src="productLines.HeatCAD.logo" :title="productLines.HeatCAD.name" class="img-logo" />
                                        <sup class="text-black text-h5 text-weight-bold on-right" style="vertical-align: top">{{ key }}</sup>
                                    </router-link>
                                </div>
                                <div class="text-primary text-right" style="font-size: 0.8rem; padding: 14px; width: 200px;">
                                    <a href="/support/faqs?productLine=HeatCAD" style="text-decoration: underline; font-weight: normal;">Subscription FAQs</a>
                                    <br />
                                    <label @click="showMultiLicenseDiscount = true" style="cursor: pointer; text-decoration: underline;">Multiple License Discount</label>
                                </div>
                            </div>
                            <div>
                                <div class="row justify-center text-center q-col-gutter-lg items-stretch q-mt-md">
                                    <div v-for="prod in value" :key="prod.id"
                                         class="col-xs-12 col-sm-6 col-md-4 q-pb-xl">
                                        <div :class="editionSalesFlag(prod) ? 'edition-sales-flag-borders' : ''" style="padding: 14px;">
                                            <div v-for="renewal in subscriptionRenewals.filter(p => p.productCategoryID == 'HeatCAD' && p.version == key && p.edition == prod.edition)" :key="prod.id" class="col-xs-12 col-sm-6 col-md-4">
                                                <store-product :id="prod.id" :product="prod" :renewal="renewal"
                                                               :selectedCurrency="cart.currency"
                                                               :editionSalesFlag="editionSalesFlag(prod)"
                                                               :features="productTypes[0].products.find(({ name }) => name === 'HeatCAD').featuresCompare[prod.edition]"
                                                               @buy="addToCart" @renew="addToCart">
                                                </store-product>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- PlumbingCAD Editions -->
                    <div id="pcEditions" ref="pcEditionsRef">
                        <div v-for="([key, value]) in annualSubscriptionsByYear" :key="key">
                            <div class="q-pb-lg row" style="display: flex; justify-content: space-between; align-items: center;">
                                <div class="store-category-logo" style="margin-left:calc(50% - 200px);">
                                    <router-link :to="productLines.PlumbingCAD.page">
                                        <img :src="productLines.PlumbingCAD.logo" :title="productLines.PlumbingCAD.name" class="img-logo" />
                                        <sup class="text-black text-h5 text-weight-bold on-right" style="vertical-align: top">{{ key }}</sup>
                                    </router-link>
                                </div>
                                <div class="text-primary text-right" style="font-size: 0.8rem; padding: 14px; width:200px;">
                                    <a href="/support/faqs?productLine=PlumbingCAD" style="text-decoration: underline; font-weight: normal;">Subscription FAQs</a>
                                </div>
                            </div>
                            <div>
                                <div class="row justify-center text-center q-col-gutter-lg items-stretch q-mt-md">
                                    <div v-for="prod in value" :key="prod.id"
                                         class="col-xs-12 col-sm-6 col-md-4 q-pb-xl">
                                        <div :class="editionSalesFlag(prod) ? 'edition-sales-flag-borders' : ''" style="padding: 14px;">
                                            <div v-for="renewal in subscriptionRenewals.filter(p => p.productCategoryID == 'PlumbingCAD' && p.version == key && p.edition == prod.edition)" :key="prod.id" class="col-xs-12 col-sm-6 col-md-4">
                                                <store-product :id="prod.id" :product="prod" :renewal="renewal"
                                                               :selectedCurrency="cart.currency"
                                                               :editionSalesFlag="editionSalesFlag(prod)"
                                                               @buy="addToCart" @renew="addToCart">
                                                </store-product>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </section>
        </div>

        <div v-if="!getProductsForPurchasePending">
            <section class="bg-grey-2">
                <div class="container">

                    <p class="text-subtitle1 text-weight-medium">Terms & Conditions</p>
                    <ol class="text-caption">
                        <li>Sales of software are final once an activation code has been issued. Free trials are available for testing and evaluation prior to purchasing.</li>

                        <li>The currency for the transaction is either US dollars or Canadian dollars as shown above. For credit cards issued in other currencies, your credit card company determines the exchange rate used for the transaction.</li>

                        <li>Refer to the End User License Agreement for full terms and conditions.</li>
                    </ol>
                </div>
            </section>
        </div>
        <q-inner-loading :showing="getProductsForPurchasePending">
            <div>
                <q-spinner color="primary"
                           :thickness="2"
                           size="3em" />
            </div>
        </q-inner-loading>
        <q-page-sticky v-if="cart.cartItems.length > 0" position="bottom-right" :offset="[18, 18]">

            <q-btn fab icon="mdi-cart" color="primary" to="/store/cart" />
        </q-page-sticky>
        <q-dialog v-model="showLogin">
            <login @close="showLogin = false" />
        </q-dialog>

        <q-dialog v-model="showMultiLicenseSelectionDialog">
            <q-card class="col q-pa-sm" :style="!screenSize.xs ? 'max-width: 1024px' : ''">
                <q-card-section>
                    <multi-license-selection ref="multiLicenseSelectRef"
                                             :product="currentProduct"
                                             :licenses="renewLicenses"
                                             :pending="getLicensesCustomerPending"
                                             @submitted="processMultiLicenseSelection" />
                    <div class="row q-col-gutter-sm q-mt-md">
                        <div class="col-xs-12 col-sm-auto">
                            <q-btn v-if="renewLicenses.length > 0" :label="syncCartPending ? 'Processing...' : 'Continue'" type="submit" color="primary" class="full-width"
                                   :disabled="syncCartPending"
                                   @click="submitMultiLicenseSelection" />
                        </div>
                        <div class="col-xs-12 col-sm-auto">
                            <q-btn flat :label="renewLicenses.length > 0 ? 'Cancel' : 'Dismiss'" color="primary" v-close-popup class="full-width" />
                        </div>
                    </div>
                </q-card-section>
                <q-inner-loading :showing="syncCartPending">
                    <div>
                        <q-spinner color="primary"
                                   :thickness="2"
                                   size="3em" />
                    </div>
                </q-inner-loading>
            </q-card>
        </q-dialog>

        <dialog-subscription-reinstatement :show.sync="showReinstatementCostDialog"
                                           :items="reinstatementLicenseItems" />

        <dialog-multiple-license-discount :show.sync="showMultiLicenseDiscount" />

    </div>
</template>
<script>
    import multiLicenseSelection from '@/components/MultiLicenseSelection'
    import dialogSubscriptionReinstatement from '@/components/dialogs/DialogSubscriptionReinstatement'
    import dialogMultipleLicenseDiscount from '@/components/dialogs/DialogMultipleLicenseDiscount'
    import currencySelect from '@/components/CurrencySelect'
    import storeProduct from '@/components/StoreProduct'
    import { mapState } from 'vuex'
    import { productLines } from '@/plugins/productLines'
    import { productTypes } from '@/plugins/productTypes'
    import login from '@/components/Login'

    export default {
        name: 'store',
        components: {
            storeProduct,
            currencySelect,
            login,
            multiLicenseSelection,
            dialogSubscriptionReinstatement,
            dialogMultipleLicenseDiscount,
        },
        props: {
            productLine: String
        },
        data() {
            return {
                tab: 'loopcad',
                showLogin: false,
                pendingAddToCartProduct: null,
                showMultiLicenseSelectionDialog: false,
                productsForPurchase: [],
                currentProduct: null,
                productCategory: '',
                productLines: productLines,
                productTypes: productTypes,
                showMultiLicenseDiscount: false,
            }
        },
        methods: {
            getCustomerLicenses() {
                if (this.isLoggedIn && this.user) {
                    this.$store.dispatch('getLicensesCustomer', this.user.id)
                }
            },
            submitMultiLicenseSelection() {
                let component = this.$refs.multiLicenseSelectRef
                if (typeof component.onSubmit === 'function') {
                    component.onSubmit()
                }
            },
            processMultiLicenseSelection(licenses) {
                if (licenses && licenses.length > 0) {

                    const payload = {
                        product: this.currentProduct,
                        currency: this.cart.currency,
                        licenses: licenses,
                    }
                    this.$store.dispatch('syncRenewUpgradeItems', payload)
                }
                else if (this.currentProduct.isAnnualSubscription) {
                    this.$store.dispatch('addCartItem', { currency: this.cart.currency, product: this.currentProduct })
                }
            },
            getProductsForPurchase() {
                this.$store.dispatch('getProductsForPurchase', '').then(() => {
                    this.productsForPurchase = this.getProductsForPurchaseData
                })
            },
            addToCart(product) {
                if (product) {
                    if (!this.isLoggedIn && (product.isUpgrade || product.isSubscription)) {
                        this.showLogin = true
                        this.pendingAddToCartProduct = product
                        return
                    }

                    this.currentProduct = product
                    this.productCategory = product.productCategoryID

                    if (this.renewLicenses.length <= 0) {

                        if (this.productCategory == 'PlumbingCAD') {
                            product = this.annualSubscriptionsByYear.get(product.version)[0]
                        }

                        if (product.isSubscription || product.isUpgrade) {
                            this.showMultiLicenseSelectionDialog = true
                            return
                        }

                        this.$store.dispatch('addCartItem', { currency: this.cart.currency, product: product })
                        return
                    }

                    if (product.isSubscription || product.isUpgrade) {
                        if (this.renewLicenses.length == 1) {
                            //Automatically select the only license available to renew
                            this.processMultiLicenseSelection(this.renewLicenses)
                            return
                        }
                        this.pendingAddToCartProduct = null
                        this.showMultiLicenseSelectionDialog = true
                        return
                    }
                    this.$store.dispatch('addCartItem', { currency: this.cart.currency, product: product })
                }
            },
            ScrollTo(element, hash) {
                const currentHash = this.$route.hash;
                const targetHash = hash;

                if (currentHash !== targetHash) {
                    this.scrollToElement(element);
                    this.$router.push({ path: this.$route.path, hash: targetHash });
                } else {
                    this.scrollToElement(element);
                }
            },
            getCurrency(product) {
                if (this.cart.currency == 1) return product.listPriceCDN
                else return product.listPriceUS

            },
            editionSalesFlag(prod) {
                if (prod) {
                    switch (prod.productCategoryID) {
                        case 'LoopCAD':
                            switch (prod.edition) {
                                case 'MJ8':
                                    return "ACCA Manual J8";
                                    break;
                                case 'Professional':
                                    return "ASHRAE and CSA F280";
                                    break;
                                case 'Standard':
                                    return "Manual Input of Loads";
                                    break;
                            }
                        case 'HeatCAD':
                            switch (prod.edition) {
                                case 'MJ8':
                                    return "ACCA Manual J8";
                                    break;
                                case 'Professional':
                                    return "ASHRAE and CSA F280";
                                    break;
                            }
                        case 'PlumbingCAD':
                            return null;
                            break;
                        case 'LengthWise':
                            return null;
                            break;
                    }
                }
                else {
                    return null;
                }
            },
        },
        computed: {
            ...mapState([
                'getCurrenciesPending',
                'getCurrenciesData',

                'getProductsForPurchasePending',
                'getProductsForPurchaseData',

                'getLicensesCustomerData',
                'getLicensesCustomerPending',

                'syncCartPending',
                'syncCartData',
            ]),
            showReinstatementCostDialog() { return this.$store.getters.showReinstatementCostDialog },
            reinstatementLicenseItems() { return this.$store.getters.reinstatementLicenseItems },
            cartItemAdded() { return this.$store.getters.cartItemAdded },
            cart() { return this.$store.getters.cart },
            isLoggedIn() { return this.$store.getters.isLoggedIn },
            user() { return this.$store.getters.authUser },

            newLoopCADLicensesByYear() {
                if (!this.newLicenses.length) return []
                var newLicensesByYear = this.groupBy(this.newLicenses.filter(p => p.productCategoryID == 'LoopCAD'), t => t.version)
                return newLicensesByYear
            },
            newHeatCADLicensesByYear() {
                if (!this.newLicenses.length) return []
                var newLicensesByYear = this.groupBy(this.newLicenses.filter(p => p.productCategoryID == 'HeatCAD'), t => t.version)
                return newLicensesByYear
            },
            lcLowestLicensePrice() {
                if (!this.newLoopCADLicensesByYear.size) return null
                const year = Array.from(this.newLoopCADLicensesByYear.keys())[0];
                const productForYear = this.newLoopCADLicensesByYear.get(year);
                const product = productForYear[0];

                const lowestPrice = this.getCurrency(product);
                return lowestPrice;
            },
            hcLowestLicensePrice() {
                if (!this.newHeatCADLicensesByYear.size) return null
                const year = Array.from(this.newHeatCADLicensesByYear.keys())[0];
                const productForYear = this.newHeatCADLicensesByYear.get(year);
                const product = productForYear[0];

                const lowestPrice = this.getCurrency(product);
                return lowestPrice;
            },
            pcAnnualPrice() {
                if (!this.annualSubscriptionsByYear.size) return null
                const year = Array.from(this.annualSubscriptionsByYear.keys())[0];
                const productForYear = this.annualSubscriptionsByYear.get(year);
                const product = productForYear[0];

                const lowestPrice = this.getCurrency(product);
                return lowestPrice;
            },

            annualSubscriptionsByYear() {
                if (!this.annualSubscriptions.length) return []
                var annualSubscriptionsByYearFromAnnualSubscriptions = this.groupBy(this.annualSubscriptions, t => t.version)
                return annualSubscriptionsByYearFromAnnualSubscriptions
            },
            otherProductsByYear() {
                if (!this.annualSubscriptions.length) return []
                var otherProductsByYearFromOtherProducts = this.groupBy(this.otherProducts, t => t.version)
                return otherProductsByYearFromOtherProducts
            },

            newLicenses() {
                if (!!this.productsForPurchase.length) {
                    var newLicensesFromProductsForPurchase = this.productsForPurchase?.filter(p => p.isSubscription == false && p.isUpgrade == false && p.licenseText == 'Full' && p.productCategoryID !== 'LengthWise' && p.visible == true).sort((a, b) => a.listPriceUS - b.listPriceUS)
                    return newLicensesFromProductsForPurchase
                }

                return []
            },
            subscriptionRenewals() {
                if (!!this.productsForPurchase.length) {
                    var subscriptionRenewalsFromProductsForPurchase = this.productsForPurchase?.filter(p => p.isSubscription == true && p.visible == true).sort((a, b) => a.listPriceUS - b.listPriceUS)
                    return subscriptionRenewalsFromProductsForPurchase
                }
                return []
            },
            annualSubscriptions() {
                if (!!this.productsForPurchase.length) {
                    var annualSubscriptionsFromProductsForPurchase = this.productsForPurchase?.filter(p => p.productCategoryID == 'PlumbingCAD' && p.isSubscription == false && p.isUpgrade == false && p.visible == true).sort((a, b) => a.listPriceUS - b.listPriceUS)
                    return annualSubscriptionsFromProductsForPurchase
                }
                return []
            },
            otherProducts() {
                if (!!this.productsForPurchase.length) {
                    var otherProductsFromProductsForPurchase = this.productsForPurchase?.filter(p => p.productCategoryID == 'LengthWise' && p.visible == true).sort((a, b) => a.listPriceUS - b.listPriceUS)
                    return otherProductsFromProductsForPurchase
                }
                return []
            },

            renewLicenses() {
                if (this.getLicensesCustomerData && this.productCategory) {
                    var renewLicensesFromCustomerData = this.getLicensesCustomerData?.filter(l => l.canRenew == true && l.productCategory == this.productCategory && l.active).sort((a, b) => new Date(a.expiry) - new Date(b.expiry)).sort((a, b) => a.listPriceUS - b.listPriceUS)

                    if (this.productCategory == 'PlumbingCAD') {
                        renewLicensesFromCustomerData = renewLicensesFromCustomerData.filter(l => !this.isExpired(l.expiry))
                    }

                    return renewLicensesFromCustomerData
                }
                return []
            },
            screenSize() {
                return this.$q.screen
            },
        },
        created() {
            this.getProductsForPurchase()
            this.getCustomerLicenses()
        },
        watch: {
            isLoggedIn(newVal) {
                if (newVal) {
                    this.showLogin = false
                    this.$store.dispatch('getLicensesCustomer', this.user.id).then(() => {
                        if (this.pendingAddToCartProduct) this.addToCart(this.pendingAddToCartProduct)
                    })
                }
            },
            cartItemAdded(newVal) {
                if (newVal) {
                    this.showMultiLicenseSelectionDialog = false
                    if (!this.showReinstatementCostDialog) {
                        this.$router.push('/store/cart').catch(err => { })
                    }
                }
            },
        },
        mounted() {
            if (this.$route.query.productLine) {
                if (Object.keys(productLines)?.map(key => { return productLines[key] })?.find(pl => pl.name.toLowerCase() == this.$route.query.productLine.toLowerCase())) {
                    if (this.$route.query.productLine.toLowerCase() == 'loopcad') {
                        setTimeout(() => {
                            this.scrollToElement(this.$refs.lcEditionsRef)
                        }, 500)
                    }
                    else if (this.$route.query.productLine.toLowerCase() == 'heatcad') {
                        setTimeout(() => {
                            this.scrollToElement(this.$refs.hcEditionsRef)
                        }, 500)
                    }
                    else if (this.$route.query.productLine.toLowerCase() == 'plumbingcad') {
                        setTimeout(() => {
                            this.scrollToElement(this.$refs.pcEditionsRef)
                        }, 500)
                    }
                }

                this.$router.replace({
                    path: this.$route.path,
                    query: {},
                }).catch(err => { })
            }
            else if (this.$route.hash == '#lcEditions') {
                setTimeout(() => {
                    this.scrollToElement(this.$refs.lcEditionsRef)
                }, 500)
            }
            else if (this.$route.hash == '#hcEditions') {
                setTimeout(() => {
                    this.scrollToElement(this.$refs.hcEditionsRef)
                }, 500)
            }
            else if (this.$route.hash == '#pcEditions') {
                setTimeout(() => {
                    this.scrollToElement(this.$refs.pcEditionsRef)
                }, 500)
            }
            else if (this.productLine) {
                if (Object.keys(productLines)?.map(key => { return productLines[key] })?.find(pl => pl.name.toLowerCase() == this.productLine.toLowerCase())) {
                    if (this.productLine.toLowerCase() == 'loopcad') {
                        setTimeout(() => {
                            this.scrollToElement(this.$refs.lcEditionsRef)
                        }, 500)
                    }
                    else if (this.productLine.toLowerCase() == 'heatcad') {
                        setTimeout(() => {
                            this.scrollToElement(this.$refs.hcEditionsRef)
                        }, 500)
                    }
                    else if (this.productLine.toLowerCase() == 'plumbingcad') {
                        setTimeout(() => {
                            this.scrollToElement(this.$refs.pcEditionsRef)
                        }, 500)
                    }
                }
            }
        },

    }
</script>
<style lang="scss" scoped>
    @import "../../styles/quasar.variables.scss";

    .tab-active {
        color: $primary !important;
        background: #eeeeee !important;
        border-top: 2px solid $primary !important;
        border-bottom: 1px solid transparent !important;
        box-shadow: none !important;
    }

    .tab-active-mobile {
        background: $secondary !important;
        color: white !important;
        box-shadow: none !important;
    }

    .tab-mobile {
        color: $accent;
        border-top: 1px solid $accent;
        background: #f8f9f9;
    }

    .tab-bottom-mobile {
        border-bottom: 1px solid $accent;
    }

    .tab-left-end {
        margin-left: 0px !important;
    }

    .tab-right-end {
        margin-right: 0px !important;
    }

    .tab {
        color: $accent;
        background: #f8f9f9;
        border: 1px solid $accent;
        margin-left: -1px;
        margin-right: -1px;
        box-shadow: 0 -7px 9px -7px rgba(0, 0, 0, 0.20) inset;
    }

    .tabs-container {
        border-bottom: 1px solid $accent;
        border-top: none;
        padding: 0;
        margin-bottom: 0;
    }

    .inset-shadow-down {
        box-shadow: 0 -7px 9px -7px rgba(0, 0, 0, 0.20) inset !important;
    }

    @media (max-width: $breakpoint-xs-max) {
        .img-logo {
            max-height: 55px;
        }
    }

    .img-icon {
        max-height: 1em;
    }

    .toggle-btn {
        border-radius: 4px;
    }

    .toggle-btn .q-btn[aria-pressed="true"] {
        border-radius: 4px;
        box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12);
    }

    .edition-sales-flag-borders {
        border: 4px solid rgba(22, 70, 111, 0.05);
        border-radius: 4px;
        padding: 10px !important;
    }

    .store-category-logo a:focus, .store-category-logo a:hover {
        text-decoration: none !important;
    }

    </style>
